/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `battery` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class BatteryMesg : Mesg {
    public constructor() : super("Battery", Profile.MesgNum.BATTERY)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** capacity, in %. */
    public var capacity: UByte?
        get() = getFieldValue(CAPACITY_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CAPACITY_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val CAPACITY_FIELD_NUM: UByte = 2u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[2] = Field("Capacity", 2u, BaseType.UINT8, 1.0, 0.0, "%", false)
            return fields
        }
    }
}
